import React from 'react';
import './aboutus.css';

function AboutUs() {
  return (
    <div className="about-us-container">
<div className="about-us-header relative">
  <img
    src="/eye care 2027 banner.png"  
    alt="Diyatharippu Conference"
    className="w-full h-64 object-cover rounded-lg mb-4"
  />
  <div className="text-aboutus">
    <h1 className="title-aboutus" style={{textAlign: 'center'}}> E Y E&nbsp;&nbsp;C A R E &nbsp;&nbsp;2 0 2 7 - S A A R C &nbsp; OPTOMETRY &nbsp; CONFERENCE </h1>
    <h3 className="subtitle-aboutus" style={{textAlign: 'center'}}></h3>
  </div>
</div>

<div className="about-us-content">
  <p className="content-text">
    EYE CARE 2027 – SAARC Optometry Conference is a landmark regional gathering that unites optometrists, vision scientists, educators, and eye care professionals from across the SAARC nations. This prestigious conference is dedicated to advancing eye care standards through knowledge sharing, innovation, and regional collaboration.
  </p>

  <h3 className="section-heading">Regional Excellence & Innovation</h3>
  <p className="content-text">
    Engage with leading experts from the SAARC region and beyond as they share insights on emerging trends, clinical advancements, and research in optometry and vision science. EYE CARE 2027 serves as a platform to inspire innovation and elevate professional practice.
  </p>

  <h3 className="section-heading">SAARC Collaboration & Networking</h3>
  <p className="content-text">
    Connect with fellow professionals, academic leaders, and industry partners from South Asia. This conference fosters meaningful networking opportunities that encourage cross-border collaboration and strengthen the future of optometry within the SAARC community.
  </p>

  <h3 className="section-heading">Cultural Unity & Academic Growth</h3>
  <p className="content-text">
    Experience the warmth and diversity of Sri Lanka while engaging in high-quality academic sessions. EYE CARE 2027 blends professional development with cultural exchange, creating a unique environment where learning and regional unity come together.
  </p>

  <div className="closing-note">
    <p>
      Join us at EYE CARE 2027 as we unite the SAARC optometry community <br />to shape a stronger, more connected future for eye care.
    </p>

    <a href="/payment" className="register-btn-aboutus">Register Now</a>
  </div>
</div>

    </div>

 
  );
}

export default AboutUs;
